import { InternalLoanRecord } from '../types/borrowerChecker'

export const MOCK_INTERNAL_RECORDS: InternalLoanRecord[] = [
  {
    lenderLoanId: 'LL-1001',
    borrowerName: 'John Martinez',
    loanAmount: 425000,
    loanDate: '2024-01-15',
    propertyAddress: '123 Oak Ave, Denver, CO',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1002',
    borrowerName: 'Emily Watson',
    loanAmount: 310000,
    loanDate: '2024-02-03',
    propertyAddress: '456 Elm St, Austin, TX',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1003',
    borrowerName: 'Robert Kim',
    loanAmount: 550000,
    loanDate: '2024-01-22',
    propertyAddress: '789 Pine Rd, Seattle, WA',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1005',
    borrowerName: 'Sarah Johnson',
    loanAmount: 275000,
    loanDate: '2024-03-10',
    propertyAddress: '321 Maple Dr, Portland, OR',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1006',
    borrowerName: 'Michael Brown',
    loanAmount: 680000,
    loanDate: '2024-02-18',
    propertyAddress: '654 Cedar Ln, San Jose, CA',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1008',
    borrowerName: 'Lisa Chen',
    loanAmount: 390000,
    loanDate: '2024-01-30',
    propertyAddress: '987 Birch Ct, Phoenix, AZ',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1010',
    borrowerName: 'David Park',
    loanAmount: 445000,
    loanDate: '2024-03-05',
    propertyAddress: '147 Walnut Way, Nashville, TN',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1011',
    borrowerName: 'Jennifer Lee',
    loanAmount: 520000,
    loanDate: '2024-02-25',
    propertyAddress: '258 Spruce Ave, Charlotte, NC',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1013',
    borrowerName: 'Thomas Wright',
    loanAmount: 365000,
    loanDate: '2024-01-08',
    propertyAddress: '369 Ash Blvd, Minneapolis, MN',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1015',
    borrowerName: 'Amanda Davis',
    loanAmount: 290000,
    loanDate: '2024-03-18',
    propertyAddress: '741 Poplar St, Raleigh, NC',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1016',
    borrowerName: 'Christopher Hall',
    loanAmount: 610000,
    loanDate: '2024-02-12',
    propertyAddress: '852 Willow Rd, Tampa, FL',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1018',
    borrowerName: 'Jessica Taylor',
    loanAmount: 475000,
    loanDate: '2024-01-28',
    propertyAddress: '963 Hickory Ln, Columbus, OH',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1020',
    borrowerName: 'Daniel Garcia',
    loanAmount: 335000,
    loanDate: '2024-03-22',
    propertyAddress: '159 Chestnut Dr, Indianapolis, IN',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1021',
    borrowerName: 'Michelle Robinson',
    loanAmount: 580000,
    loanDate: '2024-02-07',
    propertyAddress: '267 Sycamore Ct, San Diego, CA',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1023',
    borrowerName: 'Kevin Anderson',
    loanAmount: 410000,
    loanDate: '2024-01-19',
    propertyAddress: '378 Magnolia Ave, Jacksonville, FL',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1025',
    borrowerName: 'Stephanie Wilson',
    loanAmount: 305000,
    loanDate: '2024-03-14',
    propertyAddress: '489 Dogwood St, Memphis, TN',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1027',
    borrowerName: 'Brian Thompson',
    loanAmount: 720000,
    loanDate: '2024-02-22',
    propertyAddress: '591 Redwood Blvd, San Francisco, CA',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1029',
    borrowerName: 'Nicole Martinez',
    loanAmount: 350000,
    loanDate: '2024-01-12',
    propertyAddress: '602 Cypress Way, Las Vegas, NV',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1030',
    borrowerName: 'Andrew Clark',
    loanAmount: 495000,
    loanDate: '2024-03-01',
    propertyAddress: '713 Juniper Rd, Oklahoma City, OK',
    status: 'Active',
  },
  {
    lenderLoanId: 'LL-1032',
    borrowerName: 'Rachel Lewis',
    loanAmount: 260000,
    loanDate: '2024-02-15',
    propertyAddress: '824 Hawthorn Ln, Louisville, KY',
    status: 'Active',
  },
]

export const MOCK_RUNNING_USER = {
  id: 'USR-001',
  name: 'Sarah Chen',
  email: 'sarah.chen@company.com',
}

export const OPS_DISTRIBUTION_EMAIL = 'ops-team@company.com'

export const SAMPLE_SNAPSHOT_CSV = `Lender Loan ID,Borrower Name,Loan Amount,Loan Date,Property Address,Loan Type
LL-1001,John Martinez,425000,2024-01-15,"123 Oak Ave, Denver, CO",Conventional
LL-1002,Emily Watson,310000,2024-02-03,"456 Elm St, Austin, TX",FHA
LL-1003,Robert Kim,550000,2024-01-22,"789 Pine Rd, Seattle, WA",Conventional
LL-1004,Patricia Nguyen,385000,2024-02-14,"112 Sunset Blvd, Miami, FL",VA
LL-1005,Sarah Johnson,275000,2024-03-10,"321 Maple Dr, Portland, OR",Conventional
LL-1007,Marcus Rivera,462000,2024-01-25,"445 Harbor View Dr, Boston, MA",Jumbo
LL-1008,Lisa Chen,390000,2024-01-30,"987 Birch Ct, Phoenix, AZ",FHA
LL-1009,William Foster,528000,2024-03-02,"667 Lakeshore Rd, Chicago, IL",Conventional
LL-1010,David Park,445000,2024-03-05,"147 Walnut Way, Nashville, TN",Conventional
LL-1012,Catherine O'Brien,315000,2024-02-20,"223 River Bend Ln, Atlanta, GA",FHA
LL-1013,Thomas Wright,365000,2024-01-08,"369 Ash Blvd, Minneapolis, MN",VA
LL-1014,Samantha Patel,695000,2024-03-15,"890 Hilltop Cir, Los Angeles, CA",Jumbo
LL-1015,Amanda Davis,290000,2024-03-18,"741 Poplar St, Raleigh, NC",Conventional
LL-1017,George Hernandez,410000,2024-01-20,"534 Valley Rd, Salt Lake City, UT",Conventional
LL-1018,Jessica Taylor,475000,2024-01-28,"963 Hickory Ln, Columbus, OH",FHA
LL-1019,Rebecca Stone,342000,2024-02-28,"178 Meadow Ln, Kansas City, MO",VA
LL-1020,Daniel Garcia,335000,2024-03-22,"159 Chestnut Dr, Indianapolis, IN",Conventional
LL-1022,Franklin Moore,588000,2024-01-05,"401 Summit Ave, Denver, CO",Jumbo
LL-1024,Olivia Barnes,278000,2024-03-08,"756 Creekside Dr, Tucson, AZ",FHA
LL-1010,David Park,445000,2024-03-05,"147 Walnut Way, Nashville, TN",Conventional
,Missing ID Borrower,250000,2024-02-10,"999 Unknown St, Nowhere, XX",Conventional
LL-1026,Henry Washington,465000,2024-02-05,"312 Orchard Pl, Richmond, VA",VA
LL-1028,Diana Cruz,395000,2024-03-20,"628 Brookside Ter, Milwaukee, WI",Conventional`
